import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { audience } from '../../data/salesContent';
export function AudienceSection() {
  return <PageSection labelledBy="audience-title" className="bg-carbon-900" data-id="element-64" data-mp="96xhk8d470bx">
      <SectionHeading id="audience-title" title="¿Para quién es este sistema?" subtitle="Ideal para:" data-id="element-65" data-mp="941hoehpi1ku" />
      <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-66" data-mp="3cn47lc2lwz28">
        {audience.map(({
        label,
        icon: Icon
      }) => <li key={label} className="flex items-center gap-3 rounded-lg border border-carbon-800 bg-carbon-950 p-4 text-base font-semibold leading-snug text-carbon-100" data-id="element-67" data-mp="38m2ivp6bg5ei">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500/10 text-accent-400" data-id="element-68" data-mp="3mes6fy1htidq">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-69" data-mp="2tw4ouslpglhe" />
            </span>
            {label}
          </li>)}
      </ul>
    </PageSection>;
}